import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  &:last-child {\n    margin-right: 0;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  display: block;\n  font-weight: 400;\n\n  border-bottom: none;\n  transition: color ",
        ";\n\n  color: ",
        ";\n\n  &:hover {\n    color: ",
        ";\n  }\n\n  &:focus {\n    ",
        "\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Box, Link, Desktop, Text } from "@miro-site/core";
import { useTranslation } from "next-i18next";
import { Transition } from "react-transition-group";
import styled from "styled-components";
import { CategoryHeroBanner } from "./CategoryHeroBanner";
var SEPARATE_COLUMN_CATEGORIES_LIMIT = 12;
function splitCategories(resultArray, item, index) {
    var chunkIndex = Math.floor(index / SEPARATE_COLUMN_CATEGORIES_LIMIT);
    if (!resultArray[chunkIndex]) {
        resultArray[chunkIndex] = [];
    }
    resultArray[chunkIndex].push(item);
    return resultArray;
}
var transitionStyles = {
    entering: {
        opacity: 1,
        visibility: "visible"
    },
    entered: {
        opacity: 1,
        visibility: "visible"
    },
    exiting: {
        opacity: 0,
        visibility: "hidden"
    },
    exited: {
        opacity: 0,
        visibility: "hidden"
    }
};
var defaultStyle = {
    textAlign: "center",
    transition: "opacity 250ms ease-in-out, visibility 250ms ease-in-out",
    visibility: "hidden",
    opacity: 0
};
var getContent = function(rootGroups, onCategoryOpen) {
    return rootGroups.map(function(group) {
        return /*#__PURE__*/ _jsxs(RootGroupWrapper, {
            children: [
                /*#__PURE__*/ _jsx(RootGroupTitle, {
                    children: group.title
                }),
                /*#__PURE__*/ _jsx(CategoriesListWrapper, {
                    children: group.categories.reduce(splitCategories, []).map(function(categoryList, i) {
                        return /*#__PURE__*/ _jsx(Box, {
                            children: categoryList.map(function(category) {
                                return /*#__PURE__*/ _jsx(CategoryLink, {
                                    onClick: function(e) {
                                        if (onCategoryOpen) {
                                            e.preventDefault();
                                            onCategoryOpen(category);
                                        }
                                    },
                                    href: category.href,
                                    children: category.title
                                }, category.title);
                            })
                        }, i);
                    })
                })
            ]
        }, group.title);
    });
};
var CategoryNavContent = function(param) {
    var isVisible = param.isVisible, styles = param.styles, children = param.children;
    return /*#__PURE__*/ _jsx(Transition, {
        in: isVisible,
        timeout: 2500,
        children: function(state) {
            return /*#__PURE__*/ _jsx(Desktop, {
                $block: true,
                $styles: _object_spread_props(_object_spread({}, styles, defaultStyle, transitionStyles[state]), {
                    position: "absolute",
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 3
                }),
                children: /*#__PURE__*/ _jsx(Box, {
                    $styles: {
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        textAlign: "center"
                    },
                    children: children
                })
            });
        }
    });
};
var CategoryNavDesktop = /*#__PURE__*/ React.forwardRef(function(param, ref) {
    var _styles = param.styles, styles = _styles === void 0 ? {} : _styles, _rootGroups = param.rootGroups, rootGroups = _rootGroups === void 0 ? [] : _rootGroups, _isVisible = param.isVisible, isVisible = _isVisible === void 0 ? false : _isVisible, onCategoryOpen = param.onCategoryOpen;
    var t = useTranslation("common").t;
    return /*#__PURE__*/ _jsx(CategoryNavContent, {
        isVisible: isVisible,
        children: /*#__PURE__*/ _jsx(NavWrapperVariant, {
            ref: ref,
            children: /*#__PURE__*/ _jsxs(ContainerWrapper, {
                children: [
                    /*#__PURE__*/ _jsx(ListWrapper, {
                        children: getContent(rootGroups, onCategoryOpen)
                    }),
                    /*#__PURE__*/ _jsx(MiroverseWrapper, {
                        children: /*#__PURE__*/ _jsxs(RootGroupWrapper, {
                            children: [
                                /*#__PURE__*/ _jsx(RootGroupTitle, {
                                    children: t("miroverse-title")
                                }),
                                /*#__PURE__*/ _jsx(CategoriesListWrapper, {
                                    children: /*#__PURE__*/ _jsx(CategoryHeroBanner, {})
                                })
                            ]
                        }, "Miroverse Templates")
                    })
                ]
            })
        })
    });
});
CategoryNavDesktop.displayName = "CategoryNavDesktop";
var ContainerWrapper = styled(Box).attrs({
    $styles: {
        display: "flex"
    }
}).withConfig({
    componentId: "sc-6099d37b-0"
})(_templateObject());
var ListWrapper = styled(Box).attrs({
    $styles: {
        flex: 0,
        display: "inline-flex",
        textAlign: "left",
        flexFlow: "row nowrap",
        alignContent: "flex-start"
    }
}).withConfig({
    componentId: "sc-6099d37b-1"
})(_templateObject1());
var MiroverseWrapper = styled(Box).attrs({
    $styles: {
        flex: 0,
        flexBasis: 220,
        textAlign: "left"
    }
}).withConfig({
    componentId: "sc-6099d37b-2"
})(_templateObject2());
var commomWrapperLayout = {
    paddingTop: [
        null,
        48,
        48,
        48
    ],
    paddingBottom: [
        null,
        48,
        48,
        48
    ],
    paddingLeft: [
        null,
        95,
        95,
        95
    ],
    paddingRight: [
        null,
        53,
        53,
        53
    ],
    borderRadius: [
        null,
        16,
        16,
        16
    ],
    boxShadow: "0px 8px 44px rgba(5, 0, 56, 0.16)",
    backgroundColor: "primaryWhite"
};
var NavWrapperVariant = styled(Box).attrs(function(param) {
    var _$styles = param.$styles, $styles = _$styles === void 0 ? {} : _$styles;
    return {
        $styles: _object_spread({}, commomWrapperLayout, $styles)
    };
})({});
var RootGroupWrapper = styled(Box).attrs({
    $styles: {
        marginRight: [
            null,
            28,
            28,
            28
        ]
    }
}).withConfig({
    componentId: "sc-6099d37b-3"
})(_templateObject3());
var RootGroupTitle = styled(Text).attrs(function(props) {
    return {
        as: "div",
        $variant: "p1",
        $styles: {
            fontSize: [
                null,
                12,
                12,
                12
            ],
            marginBottom: [
                null,
                24,
                24,
                24
            ],
            fontWeight: "bold",
            lineHeight: [
                null,
                24,
                24,
                24
            ],
            letterSpacing: "1px",
            textTransform: "uppercase",
            color: props.theme.templates.colors.secondary40
        }
    };
})({});
var CategoriesListWrapper = styled(Box).attrs({
    $styles: {
        flex: 0,
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        flexDirection: "row",
        flexWrap: "nowrap"
    }
})({});
var CategoryLink = styled(Link).attrs({
    $size: "small",
    $styles: {
        marginRight: [
            null,
            16,
            16,
            16
        ],
        marginBottom: [
            null,
            8,
            8,
            8
        ],
        width: [
            null,
            160,
            160,
            160
        ]
    }
}).withConfig({
    componentId: "sc-6099d37b-4"
})(_templateObject4(), function(props) {
    return props.theme.animation.transitionDuration;
}, function(props) {
    return props.theme.colors.primaryIndigo;
}, function(props) {
    return props.theme.colors.primaryBlue;
}, function(props) {
    return props.theme.normalizeStyles(props.theme.focus.outlines.withOffset);
});
export default CategoryNavDesktop;
